import { render, staticRenderFns } from "./ChooseNumberPopup.vue?vue&type=template&id=755bdff9&scoped=true&"
import script from "./ChooseNumberPopup.vue?vue&type=script&lang=ts&"
export * from "./ChooseNumberPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseNumberPopup.vue?vue&type=style&index=0&id=755bdff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755bdff9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VRow,VStepper,VStepperContent,VStepperItems})
